import { useAccount } from "wagmi";
import truncateEthAddress from "truncate-eth-address";
import { fetchUser } from "../actions";
import { useDispatch, useSelector } from "react-redux";
import BigNumber from "bignumber.js";
import { useEffect, useState } from "react";
import { format } from "d3-format";
import Modal from "react-modal";
import xSvg from "../public/x-mark.svg";

function UserRank() {
  const { address, isConnected } = useAccount();
  const dispatch = useDispatch();

  const [modal, setModal] = useState(false);
  const openModal = () => setModal(true);
  const closeModal = () => {
    setModal(false);
    document.body.classList.remove("overflow-hidden");
  };

  let user = useSelector((state) => state.user.positions);

  useEffect(() => {
    if (isConnected) {
      dispatch(fetchUser(address));
    }
  }, [address, dispatch, isConnected]);

  useEffect(() => {
    if (user) {
      openModal();
      document.body.classList.add("overflow-hidden");
    }
  }, [user]);

  if (!isConnected) {
    return (
      <div className="text-center text-secondary-text bg-secondary border border-primary-purple rounded-lg mb-8 py-4">
        <p>Connect your wallet to find your rank.</p>
      </div>
    );
  } else {
    if (!user) {
      return (
        <div className="text-center text-secondary-text bg-secondary border border-primary-purple rounded-lg mb-8 py-4">
          <p>Sorry you're not eligible. Please see details below.</p>
        </div>
      );
    } else {
      return (
        <div>
          {user.map((user, index) => {
            return (
              <div
                className="flex items-center text-primary-text bg-secondary border border-primary-purple rounded-lg mb-8 pl-2"
                key={index}
              >
                <div className="w-1/4 py-4 rounded-l-lg">{user.rank}</div>
                <div className="w-1/4">
                  {" "}
                  {truncateEthAddress(user.subaccount.slice(0, -24))}
                </div>
                <div className="w-1/4">
                  $
                  {format(",")(
                    new BigNumber(user.pnl).dividedBy(1e18).toFixed(0)
                  )}
                </div>
                <div className="w-1/4 rounded-r-lg">
                  {new BigNumber(user.percent_pnl).dividedBy(1e16).toFixed(2)}%
                </div>
              </div>
            );
          })}
          ;
          <Modal
            isOpen={modal}
            onRequestClose={closeModal}
            className="bg-secondary rounded-lg w-96 h-auto mx-auto mt-40 focus:outline-none"
            style={{
              overlay: {
                backgroundColor: "rgba(0, 0, 0, 0.50)",
              },
            }}
          >
            <div className="px-6 py-6">
              <div className="flex justify-between items-center">
                <p className="text-primary-text font-semibold text-lg">
                  Congratulations!
                </p>
                <img
                  src={xSvg}
                  alt="xsvg"
                  className="object-contain w-6 cursor-pointer hover:bg-tertiary rounded-md"
                  onClick={closeModal}
                />
              </div>
              <div className="mt-6">
                <p className="text-secondary-text">
                  You’re eligible to participate in the Liquidity Legends
                  trading competition.
                  <br />
                  <br />
                  Please join the private Telegram group below for further
                  instructions on how to begin trading.
                </p>
              </div>
              <div className="flex mt-6 justify-center">
                <a
                  className="bg-primary-purple px-6 py-2 rounded-md text-primary-text font-semibold cursor-pointer hover:brightness-110"
                  href="https://t.me/+hcA4p0T9goc1Zjdk"
                  target="_blank"
                  rel="noreferrer"
                >
                  Join
                </a>
              </div>
            </div>
          </Modal>
        </div>
      );
    }
  }
}

export default UserRank;
